import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    withoutO: PropTypes.bool,
    onlyO: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    withoutO: false,
    onlyO: false,
    color: 'currentColor',
    className: null,
};

const DehorsIcon = ({ color, className, withoutO, onlyO }) => (
    <svg
        viewBox="0 0 1238 324"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        {!onlyO ? (
            <>
                <path
                    d="M213.1 18.1H152.2V60.8H167.4V147.3C151.7 126.7 127 114.7 101.5 114.7C44.9 114.8 0 162.3 0 218.1C0 273.5 46.1 321.1 101.8 321.1C128.4 321.1 152.4 310.6 167.3 288.1V318.1H227.8V275.4H213V18.1H213.1ZM107.8 279.1C74.5 279.1 47.5 251.8 47.5 218.8C47.5 184.7 74.5 157.4 108.5 157.4C141.1 157.4 168.4 184.4 168.4 217.3C168.5 251.1 141.9 279.1 107.8 279.1Z"
                    fill={color}
                />
                <path
                    d="M340.4 112.1C280.9 112.1 236.3 159.7 236.3 218.8C236.3 277.6 283.1 323.3 341.5 323.3C383.1 323.3 420.1 297.5 435.9 259.3H388.3C377.1 275.8 359.8 283.3 340 283.3C311.5 283.3 286.1 263.1 280.1 235.4H441.9L443.4 219.3C443.4 190.8 435.2 165.4 415.3 144.4C395.8 124.5 368.1 112.1 340.4 112.1ZM279.7 200.1C285.3 173.9 311.2 152.9 338.1 152.9C367.7 152.9 393.1 171.2 401 200.1H279.7V200.1Z"
                    fill={color}
                />
                <path
                    d="M646.3 206.5C646.3 182.5 644.8 163.1 629.8 142.8C616.3 124.5 596.5 113.6 573.3 113.6C547.5 113.6 526.1 125.6 513.4 148V18H452.9V60.7H467.7V275.3H452.9V318H528.2V275.3H513.4V214.6C513.4 199.6 513 186.9 523.1 174.5C531.3 164 544.1 158.4 557.5 158.4C572.1 158.4 585.6 164 593.8 176.7C601.7 189.4 600.5 204 600.5 218.6V275.1H585.7V317.8H661V275.1H646.2V206.5H646.3Z"
                    fill={color}
                />
                <path
                    d="M1007.9 152.2V118.1H950.8V160.8H965.6V275.4H950.8V318.1H1026.1V275.4H1011.3V224.9C1011.3 206.2 1013.5 190.1 1028.5 177.3C1039.7 167.2 1053.2 163.4 1067.8 162.7V115.9C1042 117 1019.6 128.6 1007.9 152.2Z"
                    fill={color}
                />
                <path
                    d="M1162.7 196C1148.1 192.6 1129.7 188.5 1129.7 169.8C1129.7 155.9 1142.8 148.8 1155.2 148.8C1169.4 148.8 1180.3 158.2 1181 172.4H1225.2V118.1H1191.5V132C1180.3 117.8 1164.2 114 1146.2 114C1110.6 114 1078.4 136.1 1078.4 174.3C1078.4 218.1 1116.6 229 1151.4 238C1166.8 242.1 1185.5 245.5 1185.5 265.3C1185.5 280.3 1172 290 1158.2 290C1139.5 290 1127.5 278 1126 260H1079.2V318H1114V301.5C1127.1 316.9 1145.5 323.2 1165.7 323.2C1203.1 323.2 1237.2 300.7 1237.2 260.3C1237.2 215.5 1198.7 204.3 1162.7 196Z"
                    fill={color}
                />
            </>
        ) : null}
        {!withoutO ? (
            <path
                d="M796.8 0C720 0 657.8 62.2 657.8 139C657.8 215.8 720 278 796.8 278C873.6 278 935.8 215.8 935.8 139C935.8 62.2 873.6 0 796.8 0ZM796.8 232.1C745.5 232.1 703.7 190.3 703.7 139C703.7 87.7 745.5 45.9 796.8 45.9C848.1 45.9 889.9 87.7 889.9 139C889.9 190.3 848.2 232.1 796.8 232.1Z"
                fill={color}
            />
        ) : null}
    </svg>
);

DehorsIcon.propTypes = propTypes;
DehorsIcon.defaultProps = defaultProps;

export default DehorsIcon;
